/**
 * App-level badge mappers for registry pages (REG-08, 50-registries.md §0).
 * One module so a plane, mapping, rate type, holder or sector reads the same
 * on every page. Unknown inputs fall back to `neutral`.
 */ /** Plane cards and chips. Delivery is teal, never success (that is Growth). */ export function planeVariant(plane) {
    switch(plane){
        case 'GROWTH':
            return 'success';
        case 'PROPOSAL':
            return 'violet';
        case 'DELIVERY':
            return 'teal';
        case 'MARKET':
            return 'info';
        default:
            // GOVERNMENT, VEHICLES and anything new.
            return 'neutral';
    }
}
/** LCAT mapping status and relation ("Matched to" column). */ export function mappingVariant(status, relation) {
    switch(status){
        case 'APPROVED':
            if (relation === 'EQUIVALENT') return 'success';
            if (relation === 'BROADER') return 'info';
            if (relation === 'NARROWER') return 'violet';
            return 'neutral';
        case 'PENDING':
        case 'REVIEW_NEEDED':
        case 'VEHICLE_MISMATCH':
            return 'warning';
        case 'REJECTED':
            return 'danger';
        default:
            // NONE and anything new.
            return 'neutral';
    }
}
/** Rate observation type. */ export function rateTypeVariant(type) {
    switch(type){
        case 'CEILING':
            return 'outline';
        case 'SUBK_AGREED':
            return 'success';
        case 'BILLED':
        case 'AWARDED':
            return 'info';
        case 'PROPOSED':
            return 'violet';
        case 'INFERRED':
            return 'warning';
        default:
            // FLOOR and anything new.
            return 'neutral';
    }
}
/**
 * Our position on a vehicle. NOT_ON_IT is danger in a successor column and
 * neutral for the vehicle itself.
 */ export function holderVariant(kind, context = 'vehicle') {
    switch(kind){
        case 'HOLDER':
            return 'success';
        case 'NOT_ON_IT':
            return context === 'successor' ? 'danger' : 'neutral';
        case 'THROUGH':
            return 'info';
        default:
            return 'neutral';
    }
}
/** Employer sector on a career row. */ export function employerSectorVariant(kind) {
    switch(kind){
        case 'GOVERNMENT':
        case 'HERE':
        case 'OURS':
            return 'success';
        case 'INDUSTRY':
            return 'info';
        default:
            return 'neutral';
    }
}
